import { render, staticRenderFns } from "./ChildView.vue?vue&type=template&id=09a04256&scoped=true&"
import script from "./ChildView.vue?vue&type=script&lang=js&"
export * from "./ChildView.vue?vue&type=script&lang=js&"
import style0 from "./ChildView.vue?vue&type=style&index=0&id=09a04256&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a04256",
  null
  
)

export default component.exports